/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button, Flex, Text } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';

import Account from 'solis/claude/section/account';


const Links =
[
  { route: Routes.Dashboard,       title: 'Dashboard',        desc: 'Current user dashboard' },
  { route: Routes.SectorGenerator, title: 'Sector Generator', desc: 'Polyomino enumerator' },
];


const onNavigate = (event, dispatch, route) =>
{
  dispatch.pushForeground({ route });
};


const Item = ({ route, title, desc }) =>
{
  const dispatch = use(Navigation.Dispatch);

  const onClick = useCallback(onNavigate, [ dispatch, route ]);

  return (
    <Button variant = 'ghost' color = 'gray' onClick = {onClick} style = {{ justifyContent: 'flex-start', height: 'auto', padding: 'var(--space-3)' }}>
      <Flex direction = 'column' gap = '1' align = 'start'>
        <Text size = '2' weight = 'medium'>{title}</Text>
        <Text size = '1' color = 'gray'>{desc}</Text>
      </Flex>
    </Button>
  );
};


export default () =>
(
  <Flex asChild direction = 'column' gap = '4' p = '4'>
    <nav>
      <Account />

      <Flex direction = 'column' gap = '2'>
        {Links.map(link => <Item key = {link.route} {...link} />)}
      </Flex>
    </nav>
  </Flex>
);
